import React from "react";
import InputForm from "../../../../Misc/InputForm";
import Context from "../../../../../Context";
import Blocker from "../../../../Misc/Blocker";
import { Redirect } from "react-router-dom";

export default class UserAdd extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = { pending: false, cancel: false };
  }
  cancel = () => {
    this.setState({ pending: true, cancel: true });
  };
  save = async (data) => {
    this.setState({ pending: true });
    data.passwordchange = true;
    data.passwordnotchange = false;
    let result = await this.context.api.q("/admin/user/set", data);
    if (result !== false) {
      this.context.toast("Пользователь добавлен", "success");
      this.setState({ cancel: true });
    } else {
      this.context.toast("Не удалось добавить пользователя", "error");
      this.setState({ pending: false });
    }
  };
  render() {
    let data = {};
    let key = "add";
    if (this.state.cancel) {
      return <Redirect to="/admin/users" />;
    }

    return (
      <>
        <div className="d-flex justify-content-center">
          <div className="card card-custom col-lg-6">
            <div className="card-header">
              <div className="card-title">
                <h3 className="card-label">Добавление пользователя</h3>
              </div>
            </div>
            <div className="card-body">
              <Blocker on={this.state.pending}>
                <InputForm
                  fields={{
                    username: {
                      title: "Логин",
                      type: "text",
                      validate: true,
                      error: false,
                      default: "",
                      col: "6",
                    },
                    email: {
                      title: "Email",
                      type: "text",
                      validate: false,
                      error: false,
                      default: "",
                      col: "6",
                    },
                    name: {
                      title: "Имя",
                      type: "text",
                      validate: true,
                      error: false,
                      default: "",
                      col: "6",
                    },
                    phone: {
                      title: "Телефон",
                      type: "text",
                      validate: false,
                      error: false,
                      default: "",
                      col: "6",
                    },
                    description: {
                      title: "Описание",
                      type: "text",
                      validate: false,
                      error: false,
                      default: "",
                    },
                  }}
                  data={data}
                  key={key}
                  onSubmit={this.save}
                  onCancell={this.cancel}
                />
              </Blocker>
            </div>
          </div>
        </div>
      </>
    );
  }
}
